import { useQuery } from '@apollo/client';

import {
  CategoriesQuery,
  CategoriesQueryVariables,
  Category
} from '@/__generated_graphql__/graphql';
import { GET_CATEGORIES } from '@/graphql/queries';

export const useGetCategories = () => {
  const {
    data: categoriesData,
    loading,
    error
  } = useQuery<CategoriesQuery, CategoriesQueryVariables>(GET_CATEGORIES);

  const categories = (
    categoriesData ? categoriesData.categories : []
  ) as Category[];

  return { data: categories, loading, error };
};
